// extracted by mini-css-extract-plugin
export default {"table":"sales-section_table__yDdIK","labelCell":"sales-section_labelCell__cCI8a"};